/**
 * Mobile breakpoint in pixels
 * Matches the 'sm' breakpoint used throughout the application
 */
export const MOBILE_BREAKPOINT = 640

/**
 * Checks if the user agent indicates a mobile device
 * @returns true if user agent matches mobile device patterns
 */
const isMobileUserAgent = (): boolean => {
  if (typeof navigator === 'undefined') {
    return false
  }

  const userAgent = navigator.userAgent
  return /iPhone|iPad|iPod|Android/i.test(userAgent)
}

/**
 * Mobile detection for use in router guards and utilities
 *
 * Checks both viewport width and user agent to determine if device is mobile
 *
 * @returns true if viewport width is <= 768px OR user agent indicates mobile device
 *
 * @example
 * ```typescript
 * // In a router guard
 * if (!isMobileDevice()) {
 *   return undefined
 * }
 * ```
 */
export const isMobileDevice = (): boolean => {
  // Check viewport width
  if (typeof window !== 'undefined' && window.innerWidth <= MOBILE_BREAKPOINT) {
    return true
  }

  // Check user agent for mobile devices
  return isMobileUserAgent()
}
